import { SEGMENT_CONFIG } from 'v2/common/constants/index';
import { schemaShouldShowConfigTypes, schemaTypes } from '../outputSchema/config';
import { pipeInputSchemaTypes } from './config';

const configuration = {
  type: 'coppockCurve',
  defaults: {
    chartConfig: {
      type: 'candle',
      boxUnitSize: 0,
      boxPercentage: 0,
      volumeInterval: '3 minutes',
    },
    type: 'coppockCurve',
    name: 'coppockCurve',
    config: {
      candleInterval: '5 minutes',
      wmaLength: 10,
      longRoCLength: 14,
      shortRoCLength: 11,
      valuePaths: [
        'item0.equity'
      ],
    }
  },
  searchTerms: [
    'coppockCurve'
  ],
  inputSchema: [
    {
      name: 'wmaLength',
      type: pipeInputSchemaTypes.number,
      label: 'WMALength',
    },
    {
      name: 'longRoCLength',
      type: pipeInputSchemaTypes.number,
      label: 'longROCLength',
    },
    {
      name: 'shortRoCLength',
      type: pipeInputSchemaTypes.number,
      label: 'shortROCLength',
    }
  ],
  configFormOptions: {
    valuePathEditable: true,
    configFieldOptions: {},
    valuePathSupportedSegments: [SEGMENT_CONFIG.equity, SEGMENT_CONFIG.future]
  },
  buildOutputSchema: (pipe) => {
    const { name, type } = pipe;

    return [
      {
        name,
        type: schemaTypes.number,
        indicatorType: type,
        category: 'indicator',
        label: name,
        shouldShowConfigs: [
          schemaShouldShowConfigTypes.adjustmentLeftOperand,
          schemaShouldShowConfigTypes.adjustmentRightOperand,
          schemaShouldShowConfigTypes.entryLeftOperand,
          schemaShouldShowConfigTypes.entryRightOperand,
          schemaShouldShowConfigTypes.exitLeftOperand,
          schemaShouldShowConfigTypes.exitRightOperand,
          schemaShouldShowConfigTypes.intentValuePath,
        ],
        priority: 70,
        schemaName: name
      }
    ];
  },
  isEnabled: true
};
export default configuration;
